module.exports = __webpack_public_path__ + "default.b79e1d2093e06d4597e554e3dfb77294.png";